export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const LOGIN_USER_APP = "LOGIN_USER_APP";
export const LOGOUT_USER_APP = "LOGOUT_USER_APP";
export const GET_ERRORS = "GET_ERRORS"